import React from 'react';

import { typography } from '@pray/shared/components/foundations';
import Loading from '@pray/shared/components/Loading';
import Text from '@pray/shared/components/ui/Text';
import TextExpander from '@pray/shared/components/ui/TextExpander/TextExpander';
import { cn } from '@pray/shared/utils/styles';

import styles from './FundDetails.module.scss';

type FundDetailsProps = {
  isLoading: boolean;
  title: string;
  description: string;
  subtitle?: string;
};

export default function FundDetails({ isLoading, title, description, subtitle }: FundDetailsProps) {
  if (isLoading) {
    return <LoadingHeadline />;
  }

  return (
    <div className={styles.headline}>
      <Text variant={typography.h1} className={styles.title}>
        {title}
      </Text>
      {!!subtitle && (
        <Text variant={typography.subhead} className="mt-1">
          {subtitle}
        </Text>
      )}
      {!!description && (
        <TextExpander className={styles.textExpander} expandButtonText="Show More" collapseButtonText="Show Less">
          {description}
        </TextExpander>
      )}
    </div>
  );
}

function LoadingHeadline() {
  return (
    <div className={cn(styles.headline, '!gap-0 mt-12')}>
      <Loading className="!my-1 !mb-3 h-7 w-64" />
      <Loading className="!my-1 h-5" />
      <Loading className="!my-1 h-5" />
      <Loading className="!my-1 h-5 w-48" />
    </div>
  );
}
